// extracted by mini-css-extract-plugin
export default {"card":"ExtendSongCard_card__iEdIE","image":"ExtendSongCard_image__lX08X"};